BaseModel = require('base/model')

class UserCallQueueModel extends BaseModel
  urlRoot: 'userQueues'

module.exports = UserCallQueueModel